import Prompts from "./Prompts";
export default Prompts;